export default __webpack_public_path__ + "static/media/donut_love.077c6fb1.svg";